<script>
    import { mapGetters } from "vuex";
    import { metaInfo } from "@/core/MetaInfo";
    import BaseButton from "@main/packages/BaseButton";
    import TypographyWrapper from "@/components/TypographyWrapper";

    export default {
        name: "Madcoins",
        components: { BaseButton, TypographyWrapper },
        computed: {
            ...mapGetters("Root", ["currency"]),
            buttonVariants() {
                const siteProps = {
                    picooc: ["v2", "v1"],
                    nanoleaf: ["v1", "v3"],
                    ledger: ["v1", "v5"],
                    default: ["v1", "v2"],
                };
                return siteProps[this.$root.$_name] || siteProps.default;
            },
            tags() {
                return [
                    "Копите мэдкоины",
                    `1 мэдкоин = 1 ${this.currency}`,
                    "Оплачивайте мэдкоинами до 100% покупки",
                ];
            },
            features() {
                return [
                    {
                        title: "Выгода",
                        text: "Оплачивайте до&nbsp;100% стоимости покупки бонусами",
                        icon: "ico-cashback.png",
                    },
                    {
                        title: "Привилегии",
                        text: "Бонусы и&nbsp;скидки <br />в&nbsp;День рождения",
                        icon: "ico-heart.png",
                    },
                    {
                        title: "Акции",
                        text: "Закрытые распродажи и&nbsp;специальные предложения для участников программы",
                        icon: "ico-flame.png",
                    },
                    {
                        title: "Подарки",
                        text: "Получайте подарки или приобретайте их&nbsp;за&nbsp;мэдкоины",
                        icon: "ico-gift.png",
                    },
                ];
            },
            levels() {
                return [
                    {
                        name: "Адепт",
                        text: `Совершил покупки на&nbsp;сумму от&nbsp;0&nbsp;до&nbsp;30&nbsp;000&nbsp;${this.currency}`,
                        cashback: "Кэшбэк 2%",
                        more: "Можно тратить баллы уже со&nbsp;второй покупки! + бонусы",
                    },
                    {
                        name: "Бывалый",
                        text: `Совершил покупки на&nbsp;сумму от&nbsp;30&nbsp;000 до&nbsp;100&nbsp;000&nbsp;${this.currency}`,
                        cashback: "Кэшбэк 5%",
                        more: "Участие в&nbsp;закрытых распродажах! + бонусы",
                    },
                    {
                        name: "Ветеран",
                        text: `Совершил покупки на&nbsp;сумму от&nbsp;100&nbsp;000&nbsp;${this.currency}`,
                        cashback: "Кэшбэк 7%",
                        more: "Подарки от&nbsp;магазина",
                    },
                ];
            },
        },
        metaInfo() {
            return metaInfo.getMeta("madcoins");
        },
    };
</script>

<template>
    <div class="l-container">
        <typography-wrapper>
            <div class="p-bonuses">
                <div class="p-bonuses-info">
                    <div class="p-bonuses-info__text">
                        <h2>Участвуйте в бонусной программе Madrobots!</h2>
                        <p>
                            Бонусная программа Madrobots&nbsp;&mdash; это система накопления
                            бонусов (у&nbsp;нас это мэдкоины), позволяющая совершать выгодные
                            покупки в&nbsp;магазинах
                            <a href="https://madrobots.ru/" target="_blank">madrobots.ru</a>,
                            <a href="https://xd-design.ru/" target="_blank"
                                >xd&#8209;design.ru</a
                            >, <a href="https://picooc.ru/" target="_blank">picooc.ru</a>,
                            <a href="https://petoneer.ru/" target="_blank">petoneer.ru</a>,
                            <a href="https://miku-russia.ru/" target="_blank"
                                >miku&#8209;russia.ru</a
                            >, <a href="https://chipolo.ru/" target="_blank">chipolo.ru</a>,
                            <a href="https://igarden.store/" target="_blank">igarden.store</a>,
                            <a href="https://ivideon-v.ru/" target="_blank"
                                >ivideon&#8209;v.ru</a
                            >,
                            <a href="https://martinelia.ru/" target="_blank">martinelia.ru</a>,
                            <a href="https://bivan.ru/" target="_blank">bivan.ru</a>,
                            <a href="https://ledgerwalletrussia.ru/" target="_blank"
                                >ledgerwalletrussia.ru</a
                            >
                            и <a href="https://zavtra.co/" target="_blank">zavtra.co</a>, а
                            также пользоваться дополнительными сервисами и привилегиями.
                        </p>
                    </div>
                    <img
                        src="/static/assets/madcoins/miner.png"
                        alt=""
                        class="p-bonuses-info__image mobile-hidden"
                    />
                </div>

                <div class="p-bonuses-tags">
                    <div
                        v-for="(tag, index) in tags"
                        :key="index"
                        class="p-bonuses-tags__item"
                    >
                        <div class="p-bonuses-tags__icon">
                            <img
                                :src="`/static/assets/madcoins/partic-ico-${index + 1}.png`"
                                alt=""
                            />
                        </div>

                        <span class="p-bonuses-tags__text">{{ tag }}</span>
                    </div>
                </div>

                <div class="p-bonuses-features">
                    <h2 class="p-bonuses__title">Преимущества</h2>

                    <div class="p-bonuses-features__tags">
                        <div
                            v-for="(feature, index) in features"
                            :key="index"
                            class="p-bonuses-features__tag"
                        >
                            <div class="p-bonuses-features__icon">
                                <img :src="`/static/assets/madcoins/${feature.icon}`" alt="" />
                            </div>
                            <h3 class="p-bonuses-features__title">{{ feature.title }}</h3>
                            <span class="p-bonuses-features__text" v-html="feature.text">
                            </span>
                        </div>
                    </div>
                </div>

                <div class="p-bonuses-features">
                    <h2 class="p-bonuses__title">Как получить мэдкоины</h2>

                    <div class="p-bonuses-features__tags">
                        <div class="p-bonuses-features__tag">
                            <div class="p-bonuses-features__icon">
                                <img src="/static/assets/madcoins/ico-cart.png" alt="" />
                            </div>
                            <span class="p-bonuses-features__text">
                                Совершайте покупки в&nbsp;магазине!
                            </span>
                        </div>
                        <div class="p-bonuses-features__tag">
                            <div class="p-bonuses-features__icon">
                                <img src="/static/assets/madcoins/ico-challenges.png" alt="" />
                            </div>
                            <span class="p-bonuses-features__text">
                                Участвуйте<br />в акциях!
                            </span>
                        </div>
                    </div>
                </div>

                <div class="p-bonuses-levels">
                    <h2 class="p-bonuses__title">Уровни участия</h2>

                    <div class="p-bonuses-levels__inner">
                        <div
                            v-for="(level, index) in levels"
                            :key="index"
                            class="p-bonuses-levels__item"
                        >
                            <div class="p-bonuses-levels__icon">
                                <img
                                    :src="`/static/assets/madcoins/level-${index + 1}.png`"
                                    alt=""
                                />
                            </div>
                            <div class="p-bonuses-levels__info">
                                <h3 class="p-bonuses-levels__title">
                                    {{ level.name }}
                                </h3>
                                <div class="p-bonuses-levels__text" v-html="level.text"></div>
                                <span class="p-bonuses-levels__cashback">
                                    {{ level.cashback }}
                                </span>
                                <div class="p-bonuses-levels__more" v-html="level.more"></div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="p-bonuses-about">
                    <h2 class="p-bonuses__title">Как потратить бонусы</h2>

                    <p class="p-bonuses-about__text">
                        Оплачивайте до&nbsp;100% стоимости покупок на&nbsp;сайте
                        и&nbsp;в&nbsp;магазине или продолжайте накопления и&nbsp;участвуйте
                        в&nbsp;закрытых распродажах и&nbsp;других акциях для участников
                        программы
                    </p>

                    <base-button
                        tag="a"
                        href="/document-loyalty"
                        class="p-bonuses-about__rules"
                        target="_blank"
                        :variant="buttonVariants[0]"
                        size="md"
                    >
                        Правила участия в программе
                    </base-button>

                    <base-button
                        tag="a"
                        href="/document-loyalty-faq"
                        class="p-bonuses-about__faq"
                        target="_blank"
                        size="md"
                        :variant="buttonVariants[1]"
                    >
                        Частые вопросы
                    </base-button>
                </div>
            </div>
        </typography-wrapper>
    </div>
</template>

<style lang="scss">
    .p-bonuses {
        padding-bottom: 60px;
    }

    .p-bonuses-info {
        margin-bottom: 40px;
        @include bp($bp-desktop-sm) {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            margin-bottom: 80px;
        }
    }

    .p-bonuses-info__text {
        @include bp($bp-desktop-sm) {
            max-width: 720px;
            margin-right: 20px;
        }
    }

    .p-bonuses-info__image {
        @include bp($bp-desktop-sm) {
            max-width: 348px;
        }
    }

    .p-bonuses-tags {
        margin-bottom: 40px;
        @include bp($bp-desktop-sm) {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 80px;
        }
    }

    .p-bonuses-tags__item {
        display: flex;
        align-items: center;
        margin-bottom: 15px;
        @include bp($bp-desktop-sm) {
            margin-bottom: 0;
        }
    }

    .p-bonuses-tags__icon {
        flex-shrink: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        @include box(80px);
        margin-right: 20px;
        background-color: #f2f2f2;
        border-radius: 50%;
    }

    .p-bonuses-tags__text {
        max-width: 200px;
        color: #333;
        font-size: 16px;
        line-height: 24px;
    }

    .p-bonuses__title {
        text-align: center;
    }

    .p-bonuses-features {
        margin-bottom: 10px;
        @include bp($bp-desktop-sm) {
            margin-bottom: 80px;
        }
    }

    .p-bonuses-features__tags {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }

    .p-bonuses-features__tag {
        width: 50%;
        margin-bottom: 30px;
        padding: 0 3px;
        text-align: center;
        @include bp($bp-desktop-sm) {
            width: 220px;
            margin: 0 10px;
            padding: 0;
        }
    }

    .p-bonuses-features__icon {
        display: block;
        @include box(60px);
        margin: 0 auto 8px;
        border-radius: 50%;
        @include bp($bp-desktop-sm) {
            @include box(80px);
            margin-bottom: 16px;
        }
    }

    .p-bonuses-features__title {
        font-size: 20px;
    }

    .p-bonuses-features__text {
        display: block;
        font-size: 12px;
        line-height: 20px;
        font-weight: var(--typography-text-weight);
        @include bp($bp-desktop-sm) {
            font-size: 14px;
            line-height: 24px;
        }
    }

    .p-bonuses-levels__inner {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin: 0 -10px 30px;
        text-align: center;
        @include bp($bp-desktop-sm) {
            margin-bottom: 60px;
        }
    }

    .p-bonuses-levels__item {
        width: 300px;
        margin: 0 10px 20px;
        padding: 32px 16px;
        box-shadow: 0 0 50px #f2f2f5;
        border-radius: $personal-box-radius;
    }

    .p-bonuses-levels__icon {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 140px;
        height: 140px;
        margin: 0 auto 32px;
        background: #f5f5f5 center no-repeat;
        border-radius: 50%;
        img {
            width: 78px;
        }
    }

    .p-bonuses-levels__title {
        color: #333333;
        font-size: 20px;
    }

    .p-bonuses-levels__text {
        margin-bottom: 20px;
        font-weight: var(--typography-text-weight);
        line-height: 24px;
    }

    .p-bonuses-levels__cashback {
        display: block;
        margin-bottom: 20px;
        font-weight: bold;
    }

    .p-bonuses-levels__more {
        color: #2d9cdb;
        line-height: 24px;
    }

    .p-bonuses-about__text {
        max-width: 540px;
        margin: 0 auto;
        text-align: center;
    }

    .p-bonuses-about__rules {
        margin-bottom: 10px;
        @include bp($bp-desktop-sm) {
            width: 400px;
            margin: 0 auto 20px;
        }
    }

    .p-bonuses-about__faq {
        @include bp($bp-desktop-sm) {
            margin: 0 auto;
            width: 250px;
        }
    }
</style>
